import { TLimitTimePeriod, TRGLimitTimePeriod } from 'js/hooks/socket/types';
import { FORM_FIELD_TYPE } from 'js/components/common/Form/constants';

export const ADDRESS_DETAILS_KEYS = [
    'buildingName',
    'buildingNumber',
    'propertyName',
    'propertyNumber',
    'streetName',
    'streetNumber',
    'streetType',
    'subbuilding',
    'suburb',
    'unitNumber'
];

// map keys from GetPlayerInfo.DataMap to UpdatePlayerInfo.DataMap
export const PLAYER_INFO_DIFFERENCE_MAP = {
    bannerId: 'bannerid',
    birthDate: 'birthdate',
    bonusGroupId: 'bonusgroupid',
    clientType: 'clienttype',
    countryCode: 'countrycode',
    currency: 'currencyCode',
    firstName: 'firstname',
    funPassword: 'funpassword',
    funUsername: 'funusername',
    lastName: 'lastname',
    noBonus: 'nobonus',
    profileId: 'profileid',
    refererUrl: 'refererurl',
    remoteIp: 'remoteip',
    signupClientPlatform: 'clientPlatform',
    username: 'userName',
    vipLevel: 'viplevel',
    wantMail: 'wantmail',
    workPhone: 'workphone'
};

export const DEFAULT_VALUE_FOR_HIDE_FROM_USER_TYPES = [
    FORM_FIELD_TYPE.TEXT,
    FORM_FIELD_TYPE.EMAIL,
    FORM_FIELD_TYPE.DATE_PICKER
];

export const AREA_CODES = {
    HIDDEN: 'hidden',
    LIST: 'list',
    PREDEFINED: 'predefined'
};

export const INTERNAL_EMAIL = 'test@playtech.com';

export const DEPOSIT_LIMITS_MAP = {
    daydepositlimit: 'daily',
    weekdepositlimit: 'weekly',
    monthdepositlimit: 'monthly'
} as Record<string, TLimitTimePeriod>;

export const BET_LIMITS_MAP = {
    sessionbetlimit: 'session',
    daybetlimit: 'day',
    weekbetlimit: 'week',
    monthbetlimit: 'month'
} as Record<string, TRGLimitTimePeriod>;

export const LOSS_LIMITS_MAP = {
    sessionlosslimit: 'session',
    daylosslimit: 'day',
    weeklosslimit: 'week',
    monthlosslimit: 'month'
} as Record<string, TRGLimitTimePeriod>;

export const MONEY_FIELDS = [
    ...Object.keys(BET_LIMITS_MAP),
    ...Object.keys(LOSS_LIMITS_MAP),
    ...Object.keys(DEPOSIT_LIMITS_MAP)
];

export enum CONTACT_PREFERENCES_FIELD_TYPE {
    ACCOUNT = 'account',
    GENERAL = 'general',
    NON_PROMOTIONAL = 'nonPromotional',
    PROMOTIONAL = 'promotional',
    THIRD_PARTY = 'thirdParty'
}

export const SELECT_ALL_SUFFIX = '-selectAll';
